import { render, staticRenderFns } from "./askari.vue?vue&type=template&id=1b5657e6&scoped=true&"
import script from "./askari.vue?vue&type=script&lang=js&"
export * from "./askari.vue?vue&type=script&lang=js&"
import style0 from "./askari.vue?vue&type=style&index=0&id=1b5657e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5657e6",
  null
  
)

export default component.exports